/* eslint-disable jira/filename-case */
import { isProjectsInJiraM0Enabled } from '@jira/platform__services-native-integration-projects/src/index.tsx';

export default {
	get(): boolean {
		return isProjectsInJiraM0Enabled();
	},
};
